import request from '@/utils/request'
import { API_BASE } from '@/utils/api-url'

function isAbsoluteUrl(value) {
  return /^https?:\/\//i.test(String(value || ''))
}

function trimSlashes(value) {
  return String(value || '').replace(/^\/+|\/+$/g, '')
}

export function resolveDocumentResourceUrl(value, fallbackPath, params = {}) {
  const rawValue = String(value || '').trim()
  const apiBase = String(API_BASE || '/app').replace(/\/+$/, '')
  let url

  if (isAbsoluteUrl(rawValue)) {
    url = new URL(rawValue)
  } else if (rawValue.startsWith('/app/')) {
    const apiOrigin = isAbsoluteUrl(apiBase) ? apiBase : window.location.origin
    url = new URL(rawValue, apiOrigin)
  } else if (rawValue.startsWith('/')) {
    url = new URL(`${apiBase}${rawValue}`, window.location.origin)
  } else if (rawValue) {
    url = new URL(`${apiBase}/${trimSlashes(rawValue)}`, window.location.origin)
  } else {
    url = new URL(`${apiBase}/${trimSlashes(fallbackPath)}`, window.location.origin)
  }

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      url.searchParams.set(key, value)
    }
  })

  return url.toString()
}

export function getSharedDocument(token, password) {
  return request.get(`/share-documents/${encodeURIComponent(token)}`, {
    params: password ? { password } : undefined
  })
}

export function getSharedDocumentFileUrl(token, { password, download = false } = {}) {
  return resolveDocumentResourceUrl(
    '',
    `/share-documents/${encodeURIComponent(token)}/file`,
    { password, download: download ? 'true' : undefined }
  )
}
